import { BaseInput, BaseInputGroup } from "@/components/input/CustomInputs"
import SelectFinal from "@/components/input/Select"
import StaticDataSelect from "@/components/input/StaticDataSelect"
import { Label } from "@/components/ui/label"
import { handleFormChange } from "@/utils/formChange"
import { formInterface } from "@/interface/dataInterface"
import { Eye, EyeClosed, EyeOff } from "lucide-react"
import { FC, FormEvent, useEffect, useState } from "react"
import { usePermissions } from "react-admin"

interface Props extends formInterface {
  userRoles: { label: string; value: string }[];
}

const UsersForm: FC<Props> = ({ mode, formProp, setFormProp, userRoles }) => {
  const { data } = usePermissions();
  const [isPassVisible, setPassVisible] = useState(false);

  return (
    <div className="grid grid-cols-2 place-items-center gap-4">
      <BaseInput
        id="firstname"
        label="First name"
        value={formProp.firstname}
        setProp={setFormProp}
      />
      <BaseInput
        id="lastname"
        label="Last name"
        value={formProp.lastname}
        setProp={setFormProp}
        required={false}
      />
      <BaseInput
        id="email"
        label="Email"
        type="email"
        value={formProp.email}
        setProp={setFormProp}
      />
      {mode === "create" && (
        <BaseInputGroup
          id="password"
          label="Password"
          type={isPassVisible ? "text" : "password"}
          value={formProp.password}
          setProp={setFormProp}
          width="w-8"
        >
          <div className="py-2">
            {isPassVisible ? (
              <Eye
                className="w-5 h-5 cursor-pointer"
                onClick={() => setPassVisible((prev) => !prev)}
              />
            ) : (
              <EyeOff
                className="w-5 h-5 cursor-pointer"
                onClick={() => setPassVisible((prev) => !prev)}
              />
            )}{" "}
          </div>
        </BaseInputGroup>
      )}
      {/* <BaseInput id="phone" label="Phone number" type="tel" value={formProp.phone} setProp={setFormProp} /> */}
      <div className="w-full">
        <Label className="mb-2">Role</Label>
        <StaticDataSelect
          id="user_role"
          value={formProp.user_role}
          setValue={(e: FormEvent<HTMLSelectElement>) =>
            handleFormChange(e, setFormProp)
          }
          data={userRoles}
        />
      </div>
      {data.settings_type == "auto_service" && (
        <div className="w-full">
          <Label className="mb-2">Assign to branch</Label>
          <SelectFinal
            id="branch_id"
            value={formProp.branch_id}
            resource="branches"
            dataProp="name"
            setValue={(e: FormEvent<HTMLSelectElement>) =>
              handleFormChange(e, setFormProp)
            }
          />
        </div>
      )}
    </div>
  );
};

export default UsersForm;
